
















import Cookies from 'cookies-js';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class PolicyPopup extends Vue {
    @Prop() gaAccount: string;
    @Prop() hideRefuseButton: string;
    @Prop({default: 'icd'}) cookieName: string;

    show = false;
    showPopup = false;
    content = '';

    created() {
        let cookie = Cookies.get(this.cookieName);
        if (cookie === undefined) {
            this.show = true;
        }
        else {
            if (cookie === '{"mode":"all"}' && this.gaAccount) {
                xga(this.gaAccount);
            }
        }
    }

    mounted() {
        // Hide no-js parts.
        let e = this.$el;
        if (e instanceof HTMLElement) {
            let h = e.querySelectorAll('.no-js');
            for (let i = 0 ; i < h.length ; i++) {
                (h[i] as HTMLElement).style.display = 'none';
            }
        }
    }

    get showRefuseButton() {
        return this.hideRefuseButton != 'true';
    }

    onRefuse() {
        Cookies.set(this.cookieName, '{"mode":"no-3rd-party"}', {expires: new Date(Date.now() + 365*24*3600*1000)});
        this.show = false;
    }

    onAgree() {
        Cookies.set(this.cookieName, '{"mode":"all"}', {expires: new Date(Date.now() + 365*24*3600*1000)});
        if (this.gaAccount) {
            xga(this.gaAccount);
        }
        this.show = false;
    }
}

// Fix to remove method in IE

if (!('remove' in Element.prototype)) {
    (<any>Element.prototype).remove = function() {
        if (this.parentNode) {
            this.parentNode.removeChild(this);
        }
    };
}

// Utility function to load Google Analytics on request.

function xga(account:string) {
    const w:any = window;
    w._gaq = w._gaq || [];
    w._gaq.push(['_setAccount', account]);
    w._gaq.push(['_trackPageview']);
    (function() {
        var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;
        ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
        var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);
    })();
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/dndg/components/policy-popup.vue